module.exports = __webpack_public_path__ + "img/ChatIcon.3e1d0b57.png";